import React from 'react';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import { Button, Modal, ModalBody, Col } from 'reactstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from '../../assets/styles/style.sass';
import s2 from './dialog.sass';
import { setisNotExpiredLogin, setIsShowLoginModal } from '../../actions/user';
import { returnLocaleText } from '../../service/util';
import { logout } from '../../api/user';

class expiredLoginDialog extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    setisNotExpiredLogin: PropTypes.func.isRequired,
    setIsShowLoginModal: PropTypes.func.isRequired,
    modal: PropTypes.bool.isRequired,
  };
  constructor(props) {
    super(props);
    const langType = props.currentLocale.split('-')[0];
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    let fileLang = '';
    if (lang === 'hk') {
      fileLang = `${langType}_${lang}/`;
    }
    this.state = {
      modelDataDefaultLink: require(`../../assets/json/default/setting/general/link.json`),
      modelDataLink: require(`../../assets/json/${lang}/${fileLang}setting/general/link.json`),
      modelDataLocale: require(`../../assets/json/${lang}/${fileLang}setting/general/locale.json`),
      modelDataDefaultLocale: require(`../../assets/json/default/setting/general/locale.json`),
    };
  }

  onYes() {
    this.props.setisNotExpiredLogin();
    this.props.setIsShowLoginModal();
  }

  render() {
    const href =
      typeof this.state.modelDataLink['home'] === 'undefined'
        ? this.state.modelDataDefaultLink['home']
        : this.state.modelDataLink['home'];

    return (
      <div id="expiredLogin">
        <Modal
          size="lg"
          className={`${s2.dialog} ${s2.infoPopup}`}
          isOpen={this.props.modal}
          toggle={() => {
            this.props.setisNotExpiredLogin();
            logout();
            window.location.href = href;
          }}
        >
          <Button
            outline
            color="link"
            className={`${s.infoCloseRightButton} ${s2.dialogOverlayClose} ${
              s2.orderCancelcloseRightButton
            }`}
            onClick={() => {
              this.props.setisNotExpiredLogin();
              logout();
              window.location.href = href;
            }}
          />
          <ModalBody
            className={`${s2.infoContainer} ${s2.orderCancelContainer}`}
            style={{ padding: 0 }}
          >
            <div className={s2.infoHeadline}>
              <h2 className={s.globalFontLight}>
                {returnLocaleText(
                  this.state.modelDataLocale.login_error_modal_title,
                  this.state.modelDataDefaultLocale.login_error_modal_title,
                )}
              </h2>
            </div>
            <div className={s2.infoContent}>
              <p>
                {returnLocaleText(
                  this.state.modelDataLocale.login_error_modal_body,
                  this.state.modelDataDefaultLocale.login_error_modal_body,
                )}
              </p>
              <br />
              <Col
                md={{ size: 'auto', offset: '8' }}
                xs={{ size: '5', offset: '7' }}
              >
                <Button
                  className={`${s.button} ${s.secondary} `}
                  style={{ width: '100%' }}
                  onClick={() => {
                    this.onYes();
                  }}
                >
                  {returnLocaleText(
                    this.state.modelDataLocale.login_modal_title,
                    this.state.modelDataDefaultLocale.login_modal_title,
                  )}
                </Button>
              </Col>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
const mapState = state => ({
  currentLocale: state.intl.locale,
  modal: state.user.isShowExpiredLoginModal,
});
const mapDispatch = {
  setisNotExpiredLogin,
  setIsShowLoginModal,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(expiredLoginDialog),
);



// WEBPACK FOOTER //
// ./src/components/Dialog/expiredLoginDialog.js